import { Route } from 'kts-platform-frame/routes';
import Detail from './UI.AuthRecordDetail';
import UIComponents from './UI.Components';
import AddRest from './AddRest/index';
import { InvoiceDetails } from 'kts-platform-frame/display/part';

const parentName: string = 'authRecord'; // 路由的跟节点；

Route.addNode(
    parentName,
    { nodeName: 'authRecord/authConfirm', exact: true, path: '*/authManage/authConfirm', component: UIComponents },
    { nodeName: 'authRecord/authSelect', exact: true, path: '*/authManage/authSelect', component: UIComponents },
    { nodeName: 'authRecord/authRecord', exact: true, path: '*/authManage/authRecord', component: UIComponents },
    { nodeName: 'authRecord/authlogging', exact: true, path: '*/authManage/authlogging', component: UIComponents },
    { nodeName: 'authRecord/authlogging/addshadow', exact: true, path: '*/authManage/authlogging/addshadow/:entryLogId', component: AddRest },
    { nodeName: 'authRecord/authStatics', exact: true, path: '*/authManage/authStatics', component: UIComponents },
    { nodeName: 'authRecord/detail', exact: true, path: '*/authManage/authRecord/detail', component: Detail },
    { nodeName: 'authManage/invoiceDetail', path: '*/authManage/invoiceDetail/:loggingId', title: '发票详情', component: InvoiceDetails },

);

export default {
    getChildReact: (index?: string) => {
        return Route.getChildReact(parentName, index);
    },
    getChildDetail: () => {
        return Route.getChildRoute('authRecord/detail');
    },
};

export {
    Switch
} from 'react-router-dom';



// WEBPACK FOOTER //
// ./src/display/apps/AuthManage/Modules.Route.tsx